/** Detects whether visible text is clipped (e.g. ellipsis) inside an element. */
export const isTextTruncated = (element: HTMLElement): boolean => {
  const visibleWidth = element.clientWidth;
  if (visibleWidth <= 0) {
    return false;
  }

  if (element.scrollWidth > visibleWidth) {
    return true;
  }

  const text = element.textContent?.trim() ?? "";
  if (!text) {
    return false;
  }

  if (typeof window !== "undefined") {
    const style = window.getComputedStyle(element);
    const usesEllipsis = style.textOverflow === "ellipsis" || style.overflow === "hidden";

    if (usesEllipsis) {
      const context = document.createElement("canvas").getContext("2d");
      if (context) {
        context.font = [
          style.fontStyle,
          style.fontVariant,
          style.fontWeight,
          style.fontSize,
          style.fontFamily,
        ]
          .filter(Boolean)
          .join(" ");

        if (context.measureText(text).width > visibleWidth + 1) {
          return true;
        }
      }
    }
  }

  if (typeof document === "undefined" || typeof document.createRange !== "function") {
    return false;
  }

  try {
    const range = document.createRange();
    range.selectNodeContents(element);

    const contentWidth = range.getBoundingClientRect().width;
    const elementWidth = element.getBoundingClientRect().width;

    return contentWidth > elementWidth + 1;
  } catch {
    return false;
  }
};
